<template>
  <div v-if="!dialogFormVisible" class="cangchuRk_pupop">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title=""
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <div
        style="
          width: 90%;
          margin-left: auto;
          margin-right: auto;
          max-width: 1200px;
          padding-top: 10px;
        "
      >
        <div>
          <el-form
            ref="form"
            :rules="rules"
            label-position="right"
            :model="form"
            label-width="120px"
          >
            <el-form-item label="化学品:" prop="hxpBm">
              <el-cascader
                v-model="form.hxpBm"
                :disabled="disabled || TYPE == 'biangeng' || bgdisable"
                style="width: 100%"
                :options="hxpList"
                clearable
                @change="hxpChange"
              />
            </el-form-item>
            <el-form-item label="委托单位:" prop="wtDwMc">
              <el-select
                v-model="form.wtDwMc"
                clearable
                filterable
                :disabled="disabled || bgdisable"
                style="width: 100%"
                placeholder="请选择"
                @blur="selectBlur"
                @change="selectChange"
              >
                <el-option
                  v-for="(item, i) in wtdwList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="委托方经办人:" prop="jbName">
              <el-input
                v-model="form.jbName"
                :disabled="disabled || bgdisable"
              />
            </el-form-item>
            <el-form-item label="经办人电话:" prop="jbPhone">
              <el-input
                v-model="form.jbPhone"
                :disabled="disabled || bgdisable"
              />
            </el-form-item>
            <el-form-item label="存放仓库:" prop="ckId">
              <el-select
                v-model="form.ckId"
                :disabled="disabled"
                style="width: 100%"
                placeholder="请选择"
                @change="ckChange"
              >
                <el-option
                  v-for="(item, i) in ckList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                  @click.native="ckClickChange(item)"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="入库数量:" prop="rksl">
              <el-input
                v-model="form.rksl"
                :disabled="disabled"
                style="width: 65%"
                placeholder="请输入"
              />
              <el-select
                v-model="form.rkslDw"
                :disabled="disabled"
                style="width: calc(35% - 10px); margin-left: 10px"
                placeholder="单位"
              >
                <el-option
                  v-for="(item, i) in yzd_nsjsl_dw"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="入库日期:" prop="rkrq">
              <el-date-picker
                v-model="form.rkrq"
                :disabled="disabled"
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerBeginDateBefore"
              />
            </el-form-item>
            <el-form-item label="经办人:" prop="jbrName" class="is-required">
              <el-select
                v-model="form.jbrName"
                filterable
                :disabled="disabled || bgdisable"
                style="width: 100%"
                placeholder="请选择"
                @change="hchange"
              >
                <el-option
                  v-for="(item, i) in jbrList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="保管员姓名:">
              <el-input v-model="form.bgyxm" disabled />
            </el-form-item>
            <el-form-item label="保管员电话:">
              <el-input v-model="form.bgydh" disabled />
            </el-form-item>
            <el-form-item label="登记人:">
              <el-input v-model="form.djr" disabled />
            </el-form-item>
            <el-form-item v-if="djsjshow" label="登记时间:" prop="djsj">
              <el-date-picker
                v-model="form.djsj"
                disabled
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="备注:" style="width: 100%">
              <el-input
                v-model="form.bz"
                :disabled="disabled || TYPE == 'biangeng' || bgdisable"
                placeholder="请填写原因"
              />
            </el-form-item>
            <el-form-item
              v-if="biangengShow"
              label="变更理由:"
              style="width: 100%"
              prop="bgly"
            >
              <el-input
                v-model="form.bgly"
                placeholder="请填写变更理由"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="">
        <bgcsOfDetail
          v-if="curRowObj.bgcs >= 1"
          :cur-row-obj="curRowObj"
          :cur-type="curType"
          :bgcs-t-k-name="'仓储入库'"
          @bacsCkXqShow="bacsCkXqShow"
        />
      </div>
      <div v-if="TYPE == 'add'" class="buttonList">
        <el-button
          v-preventReClick
          class="baocun"
          type="primary"
          @click="ZSsaveTemp"
        >暂时保存</el-button>
        <el-button
          v-preventReClick
          class="ruku"
          type="primary"
          @click="ZSsave(2)"
        >入库</el-button>
      </div>
      <div v-if="TYPE == 'edit'" class="buttonList">
        <el-button
          v-preventReClick
          class="baocun"
          type="primary"
          @click="bianjiTemp"
        >暂时保存</el-button>
        <el-button
          v-preventReClick
          class="ruku"
          type="primary"
          @click="bianji(2)"
        >入库</el-button>
      </div>
      <div v-if="TYPE == 'query'" class="buttonList">
        <el-button
          v-preventReClick
          class="chakan"
          type="primary"
          @click="dialogVisible = false"
        >确定</el-button>
      </div>
      <div v-if="TYPE == 'biangeng'" class="buttonList">
        <el-button
          v-preventReClick
          class="quxiao"
          type="primary"
          @click="dialogVisible = false"
        >取消</el-button>
        <el-button
          v-preventReClick
          class="biangeng"
          type="primary"
          @click="biangengQueren()"
        >变更</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else class="cangchuRk_pupop">
    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        bgcs-t-k-name="仓储入库"
        :dgcs-xq-id="dgcsXqId"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'

import {
  getWTDW,
  getHxpCascader,
  getCkxxByCskc,
  rukuAdd,
  userInfo,
  CGEdit,
  getBGMessage,
  ccrkBG,
  getgetLyrList,
  gethqdw, CGEditTemp, rukuAddTemp
} from '@/assets/js/ccgl'
import {isEmpty} from "@/utils/tool";
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: {
    TYPE: String,
    djsjshow: Boolean,
    bgdisable: Boolean
  },
  data() {
    const rkslxg = (rule, value, callback) => {
      if (this.TYPE == 'query') {
        callback()
      }
      if (!(this.form.rksl + '')) {
        callback(new Error('请填写入库数量值'))
      }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      const reg1 = /^-?[1-9]\d{0,9}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/
      if (!this.bgdisable && !reg.test(this.form.rksl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (!reg1.test(this.form.rksl)) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      } else if (!this.form.rkslDw) {
        callback(new Error('请选择入库数量单位!'))
      }else {
        callback()
      }
    }
    return {
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      disabled: false,
      yzd_nsjsl_dw: [],
      wtdwList: [],
      jbrList: [],
      bgyXm: '',
      bgyDh: '',
      dialogVisible: false,
      hxpList: [],
      ckList: [],
      rules: {
        hxpBm: [{ required: true, message: '选择化学品', trigger: ['blur','change'] }],

        wtDwMc: [
          { required: true, message: '请选择委托单位', trigger: ['blur','change'] }
        ],

        jbrName: [{ required: true, message: '请选择经办人', trigger: ['blur','change'] }],

        jbName: [
          { required: true, message: '请输入委托方经办人', trigger: ['blur','change'] }
        ],

        jbPhone: [
          { required: true, message: '请输入委托方电话', trigger: ['blur','change'] }
        ],

        bgly: [{ required: true, message: '请输入变更理由', trigger: ['blur','change'] }],

        ckId: [{ required: true, message: '请选择存放仓库', trigger: ['blur','change'] }],
        rksl: [{ required: true, validator: rkslxg, trigger: ['blur','change'] }],
        rkrq: [{ required: true, message: '请选择入库日期', trigger: ['blur','change'] }],
        djsj: [{ required: true, message: '请选择登记日期', trigger: ['blur','change'] }]
      },
      form: {
        id: '',
        rkbh: '',
        hxpMc: '',
        hxpBm: '',
        wtDwMc: '',
        jbName: '',
        jbPhone: '',
        ckMc: '',
        ckId: '',
        rkskStr: '',
        rksl: '',
        rkslDw: '',
        rkrq: '',
        djr: '',
        djsj: '',
        bz: '',
        zt: '',
        ztStr: '',
        jbrName: '', // 经办人
        jbrId: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        bgly: ''
      },

      biangengShow: false, // 变更理由显示

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible: false,
      dgcsXqId: null
    }
  },
  computed: {},
  watch: {
    'form.hxpBm': {
      handler(curVal, oldVal) {
        if (curVal) {
          if (typeof curVal === 'string' && curVal.constructor === String) {
            gethqdw(curVal).then((res) => {
              this.yzd_nsjsl_dw = res.data.data
            })
          } else {
            gethqdw(curVal[curVal.length - 1]).then((res) => {
              this.yzd_nsjsl_dw = res.data.data
            })
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // 获取化学品
    getHxpCascader().then((e) => {
      this.hxpList = e.data.data
    })
    // 获取仓库
    getCkxxByCskc().then((e) => {
      this.ckList = e.data.data
    })
    // 获取委托单位
    getWTDW().then((e) => {
      this.wtdwList = e.data.data
    })

    getgetLyrList().then((res) => {
      this.jbrList = res.data.data
    })
  },
  mounted() {},
  methods: {
    selectBlur(e) {
      this.form.wtDwMc = e.target.value
      this.$forceUpdate()
    },
    selectChange(e) {
      this.form.wtDwMc = e
      this.$forceUpdate()
    },
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.$nextTick(() => {
        this.$refs.form.clearValidate() //清楚页面所有校验结果
      })
    },
    hchange(data) {
      this.jbrList.forEach((item) => {
        if (item.value == data) {
          this.form.jbrId = item.value
          this.form.jbrName = item.label
        }
      })
    },
    // 新增（暂时保存）
    ZSsaveTemp() {
      // 暂时保存 00 入库 01
      this.form.zt = '00'
      const [tishiMes, mesTitle] = ['是否保存为草稿状态?', '保存成功']
      this.tishi(tishiMes)
        .then(() => {
          rukuAddTemp(this.form).then((e) => {
            this.message('success', mesTitle)
            this.dialogVisible = false
            this.$parent.info()
          })
        })
        .catch(() => {
          this.message('info', '已取消')
        })
    },
    // 新增（入库）
    ZSsave(type) {
      // 暂时保存 00 入库 01
      type == 1 ? (this.form.zt = '00') : (this.form.zt = '01')
      const [tishiMes, mesTitle] =
        type == 1
          ? ['是否保存为草稿状态?', '保存成功']
          : ['是否入库?', '入库成功']
      this.$refs['form'].validate((valid) => {
        if (valid) {
      this.tishi(tishiMes)
        .then(() => {
              rukuAdd(this.form).then((e) => {
                this.message('success', mesTitle)
                this.dialogVisible = false
                this.$parent.info()
              })
        })
        .catch(() => {
          this.message('info', '已取消')
        })
        }
      })
    },
    // 确认弹窗
    tishi(title) {
      return this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 消息提示
    message(type, title) {
      return this.$message({
        type: type,
        message: title
      })
    },
    // 化学品下拉值变化时
    hxpChange(val) {
      if (val) {
        this.form.hxpBm = val[val.length - 1]
      }
    },
    // 仓库值变化时
    ckChange(val) {
      this.ckList.forEach((e) => {
        if (e.value == val) {
          this.form.bgyxm = e.ckbgy
          this.form.bgydh = e.ckbgyDh
          this.form.bgyId = e.ckbgyId
        }
      })
    },
    ckClickChange(data) {
      this.bgyXm = data.ckbgy
      this.bgyDh = data.ckbgyDh
    },
    // 变更校验
    biangengQueren() {
      getBGMessage(this.form).then((e) => {
        if (e.data.data.type == 'success') {
          ccrkBG(this.form).then((data) => {
            this.message(e.data.data.type, '变更成功')
            this.dialogVisible = false
            this.$parent.info()
          })
        } else {
          this.tishi(e.data.data.msg).then(() => {
            ccrkBG(this.form).then((data) => {
              this.message(e.data.data.type, '变更成功')
              this.dialogVisible = false
              this.$parent.info()
            })
          })
        }
      })
    },
    // 编辑(暂时保存)
    bianjiTemp() {
      // 暂时保存 00 入库 01
      this.form.zt = '00'
      const [tishiMes, mesTitle] =['是否保存为草稿状态?', '保存成功']
      this.tishi(tishiMes)
        .then(() => {
          CGEditTemp(this.form).then((e) => {
            this.message('success', mesTitle)
            this.dialogVisible = false
            this.$parent.info()
          })
        })
        .catch(() => {
          this.message('info', '已取消')
        })
    },
    // 编辑(入库)
    bianji(type) {
      // 暂时保存 00 入库 01

      type == 1 ? (this.form.zt = '00') : (this.form.zt = '01')
      const [tishiMes, mesTitle] =
        type == 1
          ? ['是否保存为草稿状态?', '保存成功']
          : ['是否入库?', '入库成功']
      this.$refs['form'].validate((valid) => {
        if (valid) {
      this.tishi(tishiMes)
        .then(() => {
              CGEdit(this.form).then((e) => {
                this.message('success', mesTitle)
                this.dialogVisible = false
                this.$parent.info()
              })

        })
        .catch(() => {
          this.message('info', '已取消')
        })
        }
      })
    },
    formatLongDate(date) {
      const myyear = date.getFullYear()
      let mymonth = date.getMonth() + 1
      let myweekday = date.getDate()
      let myHour = date.getHours()
      let myMin = date.getMinutes()
      let mySec = date.getSeconds()

      if (mymonth < 10) {
        mymonth = '0' + mymonth
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday
      }
      if (myHour < 10) {
        myHour = '0' + myHour
      }
      if (myMin < 10) {
        myMin = '0' + myMin
      }
      if (mySec < 10) {
        mySec = '0' + mySec
      }
      return myyear + '-' + mymonth + '-' + myweekday
    },
    // 新增可以编辑
    add() {
      this.form = {
        id: '',
        rkbh: '',
        hxpMc: '',
        hxpBm: '',
        wtDwMc: '',
        jbName: '',
        jbPhone: '',
        ckMc: '',
        ckId: '',
        rkskStr: '',
        rksl: '',
        rkslDw: '',
        rkrq: '',
        djr: '',
        djsj: '',
        bz: '',
        zt: '',
        ztStr: ''
      }
      this.yzd_nsjsl_dw = []
      this.bgyXm = ''
      this.bgyDh = ''
      this.dialogVisible = true
      this.disabled = false
      userInfo().then((e) => {
        this.form.djr = e.data.data.name
        this.form.djsj = this.formatLongDate(new Date())
      })
    },
    // 复制新增
    fuzhi(data) {
      this.ckChange(data.ckId)
      this.disabled = false
      this.dialogVisible = true
      const newData = { ...data }
      this.form = newData
    },
    // 查看不可编辑
    query(data) {
      this.ckChange(data.ckId)
      this.dialogVisible = true
      this.disabled = true
      this.form = data
    },
    // 编辑
    edit(data) {
      this.ckChange(data.ckId)
      this.disabled = false
      this.dialogVisible = true
      const newData = { ...data }
      this.form = newData
      if(isEmpty(newData.hxpBm)){
        this.form.rkslDw = ''
      }

      userInfo().then((e) => {
        this.form.djr = e.data.data.name
      })
      if(data.hxpBm){
        gethqdw(data.hxpBm).then((res) => {

          res.data.data.forEach((item) => {
            if (data.rkslDw == item.value) {
              this.form.rkslDw = item.value
            }
          })
        })
      }

    },
    // 变更
    biangeng(data) {
      this.ckChange(data.ckId)
      this.dialogVisible = true
      this.disabled = false
      const newData = { ...data }
      this.form = newData
      this.yzd_nsjsl_dw.forEach((item) => {
        console.log(item)
      })

      gethqdw(data.hxpBm).then((res) => {
        res.data.data.forEach((item) => {
          if (data.rkslDw == item.value) {
            this.form.rkslDw = item.value
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='less'>
.cangchuRk_pupop {
  .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
      width: 45%;
    }
  }
  .buttonList {
    width: 498px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    .baocun,
    .quxiao {
      margin-right: 190px;
      background-color: #ebebeb;
      width: 148px;
      height: 60px;
      color: #333333;
      border: none;
    }
    .ruku,
    .biangeng,
    .chakan {
      background-color: #4170ff;
      color: white;
      width: 148px;
      height: 60px;
      border: none;
    }
  }
}
</style>
